import { render, staticRenderFns } from "./VendingCategoriesPanel.vue?vue&type=template&id=18415de8&scoped=true"
import script from "./VendingCategoriesPanel.vue?vue&type=script&lang=js"
export * from "./VendingCategoriesPanel.vue?vue&type=script&lang=js"
import style0 from "./VendingCategoriesPanel.vue?vue&type=style&index=0&id=18415de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18415de8",
  null
  
)

export default component.exports